export const services = [
  {
    slug: "networking-amc",
    title: "Networking AMC",
    hero: "/img/img1.jpeg", // updated
    description:
      "Our Networking AMC offers professional Annual Maintenance Contracts designed to ensure uninterrupted network connectivity for businesses. We proactively monitor your office and enterprise network to catch issues before they arise. From configuring routers and switches to optimizing bandwidth, our skilled technicians handle it all. We conduct thorough network security checks to protect your infrastructure and data. Our service covers both LAN setup and troubleshooting, delivering efficient resolutions to any network problem. Trust us for preventive care, performance tuning, and rapid issue resolution to keep your business online and secure.",
    details: [
      "Office and enterprise network monitoring",
      "Router and switch configuration",
      "LAN setup and troubleshooting",
      "Network security checks",
      "Bandwidth optimization",
      "Rapid network issue resolution"
    ],
    features: [
      "24/7 network monitoring",
      "Preventive maintenance",
      "Infrastructure optimization",
      "Quick troubleshooting support"
    ]
  },

  {
    slug: "computer-amc",
    title: "Computer AMC",
    hero: "/img/img5.jpeg", // updated
    description:
      "Our Computer AMC service provides reliable support to keep your desktops running smoothly all year round. We offer regular maintenance, including hardware diagnostics and operating system updates, to prevent potential issues. Our team specializes in virus removal, system cleaning, and performance optimization for maximum efficiency. When emergencies arise, we respond swiftly to address and resolve hardware or software failures. This service is ideal for businesses that need consistent uptime and proactive support. Experience peace of mind with expert technical assistance and tailored AMC plans.",
    details: [
      "Scheduled computer maintenance",
      "Hardware diagnostics",
      "Operating system updates",
      "Virus removal and protection",
      "Performance optimization",
      "Emergency support for system failures"
    ],
    features: [
      "Preventive system checks",
      "Performance optimization",
      "Remote technical support",
      "Quick issue resolution"
    ]
  },

  {
    slug: "laptop-amc",
    title: "Laptop AMC",
    hero: "/img/img4.jpeg", // updated
    description:
      "Our comprehensive Laptop AMC covers every aspect of laptop care, from hardware diagnostics to software updates. We offer regular preventive maintenance to extend device lifespan and boost productivity. Our technicians manage repairs, battery and keyboard replacements, and system upgrades as needed. Troubleshooting and driver installations are completed quickly, minimizing downtime for users. We also optimize hardware and software performance so your laptops always run at their best. Choose us for seamless business operations and reliable device support.",
    details: [
      "Laptop repair and diagnostics",
      "Battery and keyboard replacement",
      "Operating system troubleshooting",
      "Driver installation and updates",
      "Hardware performance upgrades",
      "Preventive system maintenance"
    ],
    features: [
      "Hardware diagnostics",
      "Software support",
      "Upgrade consultation",
      "On-site troubleshooting"
    ]
  },

  {
    slug: "server-amc",
    title: "Server AMC",
    hero: "/img/img6.jpeg", // updated
    description:
      "Our Server AMC solutions help businesses maintain robust and secure server environments. We provide ongoing server health monitoring and rapid response to any anomalies detected. Backup and disaster recovery setups safeguard your critical data against unexpected incidents. With timely server hardware maintenance and security patch updates, we ensure optimal server performance and reliability. Our experts handle data protection services tailored to your business needs. Rely on us to keep your server infrastructure efficient, secure, and always available.",
    details: [
      "Server health monitoring",
      "Backup and disaster recovery setup",
      "Security patch updates",
      "Server hardware maintenance",
      "Data protection services",
      "Performance optimization"
    ],
    features: [
      "Server monitoring",
      "Data backup solutions",
      "Security updates",
      "Infrastructure management"
    ]
  },

  {
    slug: "projector-amc",
    title: "Projector AMC",
    hero: "/img/img8.jpeg", // updated
    description:
      "Our Projector AMC is tailored to ensure your projection equipment delivers high-quality performance at all times. We conduct regular projector cleaning and servicing to prevent dust buildup and overheating. Lamp replacements and image calibrations keep your visuals sharp and bright for presentations. Detailed hardware diagnostics and HDMI connectivity checks prevent interruptions during use. We also offer preventive maintenance to enhance longevity and device reliability. Trust our expert team for consistent, dependable projector operation.",
    details: [
      "Projector cleaning and servicing",
      "Lamp replacement",
      "Image calibration",
      "Hardware diagnostics",
      "HDMI and connectivity troubleshooting",
      "Preventive maintenance"
    ],
    features: [
      "Brightness optimization",
      "Component replacement",
      "Routine servicing",
      "Technical support"
    ]
  },

  {
    slug: "cctv-amc",
    title: "CCTV AMC",
    hero: "/img/img2.jpeg", // updated
    description:
      "Our CCTV AMC program ensures your surveillance systems remain operational and secure around the clock. We offer comprehensive camera inspection, cleaning, and maintenance to guarantee clear, uninterrupted monitoring. Regular checks of your DVR or NVR systems help catch and fix issues before they impact security. We provide advanced video recording diagnostics, system upgrades, and technical support whenever needed. Our 24/7 troubleshooting support means you’re never left vulnerable. Safeguard your property with expert care and cutting-edge solutions.",
    details: [
      "Camera inspection and maintenance",
      "DVR / NVR system checks",
      "Video recording diagnostics",
      "Camera lens cleaning",
      "Security system upgrades",
      "24/7 troubleshooting support"
    ],
    features: [
      "Surveillance monitoring",
      "System upgrades",
      "Preventive maintenance",
      "Security optimization"
    ]
  },

  {
    slug: "cctv-installation",
    title: "CCTV Installation",
    hero: "/img/img3.jpeg", // updated
    description:
      "We provide professional CCTV installation services for homes, businesses, factories, and retail spaces to maximize your site security. Our experts handle site inspection, planning, and optimal camera placement for comprehensive coverage. We install high-definition/ IP cameras, configure DVR/NVR systems, and set up mobile viewing capabilities. All wiring and cable management are completed professionally for neat, reliable installations. System testing and client training ensure you're confident in using your new security system. Get peace of mind with smart, effective surveillance solutions.",
    details: [
      "Site inspection and planning",
      "HD / IP camera installation",
      "DVR / NVR configuration",
      "Mobile viewing setup",
      "Complete wiring and cable management",
      "System testing and setup"
    ],
    features: [
      "Smart surveillance systems",
      "Mobile monitoring setup",
      "Professional wiring",
      "High quality cameras"
    ]
  },

  {
    slug: "it-services",
    title: "All IT Services",
    hero: "/img/img1.jpeg", // updated (fallback, can update to something else as needed)
    description:
      "Our comprehensive IT services support businesses of all sizes with end-to-end solutions for every technical need. From IT infrastructure consulting and emergency support to hardware troubleshooting and software installations, we cover it all. Our experts help you optimize networks, implement technology upgrades, and maintain smooth operations. Trust us for technical consulting and ongoing maintenance tailored to your business requirements. With rapid response and solution-oriented support, your business stays ahead in today's technology-driven world. Experience the advantage of having an IT partner dedicated to your long-term success.",
    details: [
      "IT infrastructure consulting",
      "Emergency technical support",
      "Hardware troubleshooting",
      "Software installation",
      "Network optimization",
      "Technology upgrades"
    ],
    features: [
      "End-to-end IT solutions",
      "Technical consulting",
      "Infrastructure support",
      "Business IT maintenance"
    ]
  }
];